

























import { Component, Vue, Watch } from 'vue-property-decorator'
import FormInput from '@/components/FormInput.vue'
import CustomForm from '@/components/CustomForm.vue'
import Result from '@/components/Result.vue'
import '@/assets/main.scss'
import CustomHeader from '@/components/CustomHeader.vue'
import { Product } from '@/model/product';
import { FormularData, FormularErrors } from '@/model/form-data';
import { DeliveryDateService } from '@/service/delivery-date.service';
import { DistanceService } from '@/service/distance-service';
import { DeliveryResultService } from '@/service/delivery-result.service';
import { FormResult } from '@/model/form-result';
import { FormValidationService } from '@/service/form-validation.service';
import { WordpressInputService } from '@/service/wordpress-input.service';
import { DeliveryMethods } from '@/model/delivery-method';
import axios from 'axios';

const DATE_INDEX_SATURDAY = 6;
const DATE_INDEX_SUNDAY = 0;

@Component({
  components: {
    CustomHeader,
    Result,
    CustomForm,
    FormInput
  }
})
export default class App extends Vue {
  private readonly products: Product[];
  private readonly deliveryMethods: DeliveryMethods;
  public readonly intentions: string[];
  public formData: FormularData;
  public result: FormResult;
  public formularErrors: FormularErrors;
  public minDate = DeliveryDateService.getInitialDate();
  public mailSendingError: string | null = null;
  public mailSendingSuccess: string | null = null;
  public isSendingRequest = false;

  private duration: number | null = null;

  public constructor() {
    super();
    this.products = WordpressInputService.getProducts();
    this.deliveryMethods = WordpressInputService.getDeliveryMethods();
    this.intentions = this.products.map(product => product.intention);
    this.formData = {
      intention: this.products[0].intention,
      volume: '1',
      address: '',
      date: DeliveryDateService.getInitialDate(),
      name: '',
      number: ''
    }
    this.result = DeliveryResultService.calculateDeliveryResult(this.formData, this.products, this.deliveryMethods, this.duration);
    this.formularErrors = FormValidationService.validateFormularData(this.formData, this.duration);
  }

  public get hasError() {
    return Object.keys(this.formularErrors).length > 0;
  }

  @Watch('formData', { deep: true })
  public onFormularDataChange() {
    this.validateForm();
    this.validateDate();
  }

  @Watch('formData.address')
  public async onFormularAddressChange() {
    try {
      this.duration = await DistanceService.calculateDistance(this.formData.address);
      this.onResultChange();
    } catch (err) {
      this.duration = null;
    }
    this.validateForm();
  }

  @Watch('formData.volume')
  @Watch('formData.intention')
  public onResultChange() {
    this.result = DeliveryResultService.calculateDeliveryResult(this.formData, this.products, this.deliveryMethods, this.duration);
  }

  private validateForm() {
    this.formularErrors = FormValidationService.validateFormularData(this.formData, this.duration);
  }

  private validateDate() {
    const minDate = DeliveryDateService.calculateMinimumDeliveryDate(this.formData, this.products);
    this.minDate = minDate;
    const formDate = new Date(this.formData.date);
    if (formDate < new Date(minDate)) {
      // this.formData.date = minDate;
      // this.validateForm(); // if you want auto-date-adjust
      this.formularErrors = {
        ...this.formularErrors,
        date: 'Bitte wählen Sie einen gültigen Liefertermin (Eine LKW-Lieferung kann frühestens in 3 Tagen stattfinden)'
      }
    }

    if (formDate.getDay() === DATE_INDEX_SATURDAY || formDate.getDay() === DATE_INDEX_SUNDAY) {
      this.formularErrors = {
        ...this.formularErrors,
        date: 'Bitte wählen Sie einen gültigen Liefertermin (Nur Werktage!)'
      }
    }
  }

  public async sendRequest() {
    const ajaxUrl = 'https://www.seiringer.at/wp-admin/admin-ajax.php';
    if (this.formData && this.result && this.result.result && this.result.result.productPrice && this.result.result.deliveryPrice && this.duration) {
      this.isSendingRequest = true;
      this.mailSendingError = null;
      this.mailSendingSuccess = null;
      const requestFormData = new FormData();
      const dateFormatter = new Intl.DateTimeFormat('de');
      requestFormData.append('action', 'erdinand_email');
      requestFormData.append('volumen', this.result.result.volume.toString());
      requestFormData.append('adresse', this.formData.address);
      requestFormData.append('name', this.formData.name);
      requestFormData.append('telefonnummer', this.formData.number);
      requestFormData.append('lieferdatum', dateFormatter.format(Date.parse(this.formData.date)));
      requestFormData.append('vorhaben', this.formData.intention);
      requestFormData.append('produkt', this.result.productTitle);
      requestFormData.append('produktpreis', this.result.result.productPrice.toString());
      requestFormData.append('zustellzeit', (this.duration * 60).toFixed(2).toString());
      requestFormData.append('lieferpreis', this.result.result.deliveryPrice.toFixed(2).toString());
      requestFormData.append('gesamtpreis', (this.result.result.productPrice + this.result.result.deliveryPrice).toFixed(2).toString());

      try {
        const response = await axios.post(ajaxUrl, requestFormData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (response && response.data === 'MESSAGE_SENT') {
          this.mailSendingSuccess = 'Herzlichen Dank für Ihre Anfrage. Eine Nachricht wurde an unser Büroteam versendet. Wir melden uns bei Ihnen telefonisch.';
        } else {
          this.mailSendingError = 'Es gab einen Fehler beim Senden Ihrer Anfrage. Sie können uns auch telefonisch erreichen.';
        }
      } catch (e) {
        this.mailSendingError = 'Es gab einen Fehler beim Senden Ihrer Anfrage. Sie können uns auch telefonisch erreichen.';
      } finally {
        this.isSendingRequest = false;
      }
    }
  }
}
